import { Tooltip } from "antd";
import { useTranslation } from "react-i18next";
import { MoreToolsIcon } from "../../shared/icons";

/**
 * MoreToolsTriggerButton — the icon button that opens/closes the More Tools menu.
 */
const MoreToolsTriggerButton = ({ isDark, onToggle }) => {
  const { t } = useTranslation();

  return (
    <Tooltip title={t("more_tools")}>
      <button
        type="button"
        onClick={onToggle}
        className={`w-10 h-10 rounded-full flex items-center justify-center transition-colors cursor-pointer border-0 bg-transparent ${
          isDark ? "hover:bg-surface/[0.08]" : "hover:bg-surface-muted"
        }`}
        aria-label={t("more_tools")}
      >
        <MoreToolsIcon isDark={isDark} />
      </button>
    </Tooltip>
  );
};

export default MoreToolsTriggerButton;
